// External Imports
import { Fragment, useState } from "react";
import { MdClose } from "react-icons/md";

// Internal Imports
import { requestAdminAPI } from "../../api/posh-api";
import Heading from "../UI/Heading";
import VehicleSelector from "../vehicles-page/VehicleSelector";
import DetailPair from "../UI/DetailPair";
import SelectPair from "../UI/SelectPair";
import LoadingSpinner from "../UI/LoadingSpinner";
import Modal from "../UI/Modal";
import CustomerSelector from "../customers-page/CustomerSelector";
import LocationSelector from "../locations-page/LocationSelector";
import { constructDateObject } from "../../util/format-date";
import { addDays, addHours, format } from "date-fns";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";

/** ========================================================================
 * * AddEventModal Component
 * This component renders a form to add a maintenance log.
 * ========================================================================== */

export default function AddEventModal({ open, setOpen, onComplete }) {
  // Initialize States
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("maintenance");

  /* ======================= ADD MAINTENANCE ======================= */
  const submitHandler = async () => {
    try {
      setLoading(true);
      const payload = {
        type: document.getElementById("type").value,
        vehicleId: document.getElementById("vehicle")?.value,
        customerId: document.getElementById("customer")?.value,
        name: document.getElementById("name")?.value,
        email: document.getElementById("email")?.value,
        phone: document.getElementById("phone")?.value,
        locationId: document.getElementById("location")?.value,
        startDate: document.getElementById("startDate").value,
        startTime: document.getElementById("startTime").value,
        endTime: document.getElementById("endTime").value,
        description: document.getElementById("description").value,
      };
      // Create Date Object
      payload.start = constructDateObject(
        payload.startDate,
        payload.startTime
      )?.toISOString();
      payload.end = constructDateObject(
        payload.startDate,
        payload.endTime
      )?.toISOString();

      // Send Request
      const response = await requestAdminAPI("create-event", payload);
      onComplete(response);
      setLoading(false);
      setOpen(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal lg:w-[60vw]">
        <Heading
          title="Add Event"
          text="Avoid adding events manually. Instead, ask the customer to fill out the relevant form."
          isBackArrow={false}
        >
          <MdClose className="text-2xl icon" onClick={() => setOpen(false)} />
        </Heading>
        <div className="info lg:grid-cols-2">
          <div className="info lg:col-span-2">
            <SelectPair
              label="TYPE"
              options={[
                { id: "maintenance", name: "Maintenance" },
                { id: "sales", name: "Sales" },
              ]}
              edit={true}
              inputOptions={{
                id: "type",
                onChange: (e) => setType(e.target.value),
                value: type,
              }}
            />
            <DetailPair
              label="Date"
              edit={true}
              inputOptions={{
                id: "startDate",
                type: "date",
                defaultValue: format(addDays(new Date(), 1), "yyyy-MM-dd"),
              }}
            />
            <DetailPair
              label="Start Time"
              edit={true}
              inputOptions={{
                id: "startTime",
                type: "time",
                defaultValue: format(new Date(), "HH:mm"),
              }}
            />
            <DetailPair
              label="End Time"
              edit={true}
              inputOptions={{
                id: "endTime",
                type: "time",
                defaultValue: format(addHours(new Date(), 1), "HH:mm"),
              }}
            />
          </div>
          {type === "maintenance" ? (
            <CustomerSelector onSelect={() => {}} />
          ) : (
            <div className="grid-cols-3 lg:col-span-2 info">
              <DetailPair
                label="Full Name"
                edit={true}
                inputOptions={{ id: "name" }}
              />
              <DetailPair
                label="Email Address"
                edit={true}
                inputOptions={{ id: "email", type: "email" }}
              />
              <DetailPair
                label="Phone Number"
                edit={true}
                inputOptions={{ id: "phone", type: "tel" }}
              />
            </div>
          )}
          <VehicleSelector onSelect={() => {}} />
          <LocationSelector onSelect={() => {}} selected="DTX75218" />

          <div className="lg:col-span-2">
            <label className="text-sm text-stone-400">Details:</label>
            <textarea
              id="description"
              className="w-full border input border-stone-600"
              rows="4"
              required
            />
          </div>
          {loading ? (
            <div className="lg:col-span-2">
              <LoadingSpinnerWrapper />
            </div>
          ) : (
            <Fragment>
              <div className="btn-secondary" onClick={() => setOpen(false)}>
                Cancel
              </div>
              <div onClick={submitHandler} className="self-end btn-primary">
                Confirm
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </Modal>
  );
}
